import React from 'react'

const SvgBeerGlasFilled = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M4.012 7c-.104 1.227.5 2.5.999 3v10c0 2 1.998 2 1.998 2h7.995s1.998 0 1.998-2v-1S20 18.5 20 15v-2c0-2-1.998-2-1.998-2h-1v-1s1-1 1-2.5c0-2.948-2.998-3.5-2.998-3.5s-1.344-2-3.997-2C8.353 2 7.009 4 7.009 4c-1.879.383-2.9 1.839-2.997 3zm2.404-.512c-.512.546-.443 1.133-.315 1.52.9-.008.9.992.9.992v3.034s-.02.966.996.966 1.016-.966 1.016-.966V9s-.017-1 .983-1c2.7 0 5.915.009 5.915.009.158-.458.129-1.145-.37-1.599-.497-.454-1.327-.397-1.646-.298-.248-.685-1.066-2.108-2.889-2.108-1.874 0-2.6 1.387-2.873 2.121-.312-.125-1.073-.324-1.717.363zM17.99 16c0 .5-.5 1-1 1v-4h1v3zm-5.996-4h1v6h-1v-6zm-2.998 4h1v2h-1v-2z'
    />
  </svg>
)

export default SvgBeerGlasFilled
